import { themesConstants } from '@constants/themes';
import { themesService } from '@services';

export const themesActions = {
    getAll,
};

function getAll() {
    return dispatch => {
        dispatch(request());
        themesService.getAll().then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: themesConstants.THEMES_REQUEST };
}

function success(data) {
    return { type: themesConstants.THEMES_ALL_SUCCESS, data };
}

function failure() {
    return { type: themesConstants.THEMES_ERROR };
}
